/**
 * Consistent styling constants for modal components
 * Use these constants to ensure uniform appearance across all modals
 */

export const MODAL_STYLES = {
  // DialogActions standardized padding - compromise between existing p: 2 and p: 3
  dialogActions: {
    p: 2.5,
    gap: 1.5,
  },

  // DialogContent standardized padding
  dialogContent: {
    p: 3,
  },

  // Form container spacing
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },

  // Standardized button styling
  button: {
    height: '48px',
    minHeight: '48px',
    padding: '12px 24px',
    textTransform: 'none',
    fontWeight: '500',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },

  // Close button positioning and styling
  closeButton: (theme) => ({
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  }),

  // DialogTitle standardized styling
  dialogTitle: {
    m: 0,
    p: 2,
  },

  // Modal container with scroll customization
  dialogContentWithScroll: {
    p: 3,
    maxHeight: '60vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'var(--scrollbar-track)',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'var(--scrollbar-thumb)',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'var(--scrollbar-thumb-hover)',
    },
  },
};

/**
 * Helper function to merge custom styles with modal standards
 */
export const mergeModalStyles = (defaultStyle, customStyle = {}) => ({
  ...defaultStyle,
  ...customStyle,
});
